import { Divider, Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Api from "src/services/api";

const DynamicArticles = (props) => {
    const { intl, hirerid, title, type, count, setNotification, defaulttextcolor } = props

    const [articles, setArticles] = useState([])

    useEffect(async () => {
        await Api.get(`articles/get-all/${type}/${count}/hirer/${hirerid}`)
            .then(result => {
                if (result.data.success) {
                    setArticles(result.data.data)
                }
                else {
                    const error = result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    setNotification(true, 'error', error)
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                const error = err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                setNotification(true, 'error', error)
                Api.kickoff(err)
            })
    }, [])

    let history = useHistory()

    const handleClick = (id) => {
        let language = window.location.pathname.split('/')[1]
        if (language != "pt" && language != "es" && language != "en")
            language = "pt"

        history.push(`/${language}/article-external/${id}`)
    }

    return (
        <Grid item container direction="column" spacing={2} sm={3} padding="50px">
            <Grid item>
                <Typography variant="h4">{title}</Typography>
            </Grid>
            {
                articles.map(article => {
                    return (
                        <Grid item >
                            <Typography
                                onClick={_ => handleClick(article.id)}
                                variant="h5"
                                paddingY="12px"
                                style={{ cursor: "pointer" }}
                                color={defaulttextcolor ? defaulttextcolor : "primary"}
                            >
                                {article.title}
                            </Typography>
                            <Divider />
                        </Grid>
                    )
                })
            }
        </Grid>
    )
}

export default DynamicArticles